var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Seychelles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M34.714,7.131L7.367,35.102c0.873,1.306,1.908,2.49,3.057,3.554L43.97,23.408 C43.769,16.557,40.133,10.581,34.714,7.131z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M24,4c-2.194,0-4.299,0.366-6.274,1.019L5.172,30.694c0.557,1.566,1.286,3.049,2.194,4.408 l27.347-27.97C31.615,5.159,27.946,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M4,24c0,2.352,0.427,4.598,1.172,6.694L17.726,5.019C9.757,7.652,4,15.148,4,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-0.2-0.024-0.394-0.03-0.592L10.423,38.656c0.82,0.76,1.695,1.458,2.633,2.073l28.027-6.37 C42.922,31.335,44,27.798,44,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M41.084,34.36l-28.027,6.37C16.202,42.791,19.958,44,24,44C31.248,44,37.576,40.132,41.084,34.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Seychelles);
export default __webpack_public_path__ + "static/media/icons8-seychelles.443601710644bf7f37e97ff0e0f7ac3f.svg";
export { ForwardRef as ReactComponent };